// custom scripts
// mcs / 2023


// WINDOW SCROLLED
$(window).scroll(function() {    
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
      $("body").addClass("scrolled");
  } else {
      $("body").removeClass("scrolled");
  }
  if (scroll >= 800) {
      $("body").addClass("scrolled-longer");
  } else {
      $("body").removeClass("scrolled-longer");
  }
  if (scroll >= 20) {
      $("body").addClass("first-scrolled");
  } else {
      $("body").removeClass("first-scrolled");
  }

  if (scroll >= 400) {
     $('.promobox').removeClass('loaded');
  }
  
});





$(document).ready(function() {



  $('body').addClass('ready');
  setTimeout(function(){
    $('body').addClass('ready0');
  }, 500);
  setTimeout(function(){
    $('body').addClass('ready01');
  },600);
  setTimeout(function(){
    $('body').addClass('ready1');
  }, 1000);
  setTimeout(function(){
    $('body').addClass('ready2');

    $('.promobox').addClass('loaded');
  }, 3000);


  $(".hamburger").click(function(){
    $(this).toggleClass("is-active");
    $('.desknav').toggleClass("is-active");
  });



  $('.themenu').click(function() {
    $(this).toggleClass('active');
    $('.mcs-mobile-btns').toggleClass('active');
  });




  $('.promobox-close').click(function() {
    $('.promobox').removeClass('loaded');
  });






  // Show the first tab and hide the rest
  $('#tabs-nav li:first-child').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();

  // Click function
  $('#tabs-nav li').click(function(){
    $('#tabs-nav li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();
    
    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });




  $('.mcs-free').click(function(e){
      
      moveAlong(toAdd);
      console.log('clicekd');

      e.preventDefault();
      var toAdd = new Array();
       $(".free-item").each(function(){
          toAdd.push({
           variant_id: $(this).attr("data-varid"),
           quantity_id: 1
          });
        });
       
  });
      
  function moveAlong(toAdd) {
          

      var request = toAdd.shift();
      var variant_id = 47157706621253;
      var quantity_id = 1;
      var tempId = request.variant_id;
      var tempQty = request.quantity_id;          
      var params = {
        type: 'POST',
        url: '/cart/add.js',
              data:{ quantity: tempQty,id: tempId},
        dataType: 'json',
        success: function(line_item) { 
          moveAlong(toAdd);
        },
        error: function(xhr, status, error) {
          console.log(xhr.responseText + status + error);
          moveAlong(toAdd);
                  console.log(xhr.responseText );
        }
      };
      $.ajax(params);
    

  }




  
  // add visible to waypoints in viewport
  var viewport = $(window),
    setVisible = function (e) {
        var viewportTop = viewport.scrollTop() - 10, // add buffer to sotp area
            viewportBottom = viewport.scrollTop() + viewport.height() - 10 ;
        $('.waypoint').each(function () {
            var self = $(this),
                top = self.offset().top,
                bottom = top + self.height(),
                topOnScreen = top >= viewportTop && top <= viewportBottom,
                bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
                elemVisible = topOnScreen || bottomOnScreen;
            	self.toggleClass('visible', elemVisible);     
        });
    };
  viewport.scroll(setVisible);
  setVisible();
  


  // SCROLL TO FUNCTION
  $(function() {
    $('[data-toggle="elementscroll"]').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 130
          }, 600);
          return false;
        }
      }
    });
  });
    




  $('.prod-carousel').flickity({
    wrapAround: true,
    pageDots: false,
    cellAlign: 'left',
    pauseAutoPlayOnHover: true,
    autoPlay: false,
    prevNextButtons: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
  });


  $('.mcs-banner-img-wrap').flickity({
    wrapAround: true,
    pageDots: false,
    fade: true,
    cellAlign: 'left',
    pauseAutoPlayOnHover: true,
    autoPlay: false,
    prevNextButtons: true,
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    }
  });


  // $('.site-overlay').addClass('loaded');
  setTimeout(function(){
    $('.site-overlay').addClass('loaded');
  }, 200);
  setTimeout(function(){
    $('.site-overlay').addClass('loaded2');
  }, 400);



}); // clode doc ready







$(window).on('load', function() {

  // $('.splash-overlay').removeClass('active');


  






});

